import { useCallback, useEffect, useRef } from 'react'
import { useTranslation } from '@/utils/useTranslation'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'
import tw from 'twin.macro'
import BwiSearch from '@/icons/bwi/search.svg'
import { getLocale, localizedPath } from '@plugins/bw-i18next'

import { searchTypes } from './refinement-list'

export default function NavIcon({ cssStyle = [] }) {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const ref = useRef(null)

  const gotoSearch = useCallback(() => {
    const type = searchTypes.find((thisType) => pathname.startsWith(`/${thisType}/`))
    if (type) navigate(localizedPath(`/search/?${new URLSearchParams({ type })}`, getLocale(pathname)))
    else navigate(localizedPath('/search/', getLocale(pathname)))
  }, [pathname])

  useEffect(() => {
    if (ref.current)
      ref.current.setAttribute(
        'title',
        `${t('Search')} (${
          typeof navigator !== 'undefined' && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) ? '⌘' : 'Ctrl'
        } + K)`
      )
    const onKeyDown = (event): void => {
      if (event?.key?.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        gotoSearch()
      } else if (event?.key === 'Escape' && pathname.endsWith('/search/')) {
        event.preventDefault()
        navigate(-1)
      }
    }

    window.addEventListener('keydown', onKeyDown)

    return (): void => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [])

  return (
    <button
      type="button"
      ref={ref}
      onClick={gotoSearch}
      css={[tw`w-10 h-10 p-1 lg:(w-12 h-12 p-3) hover:(text-gray-300) dark:hover:text-tealBlue`, ...cssStyle]}
    >
      <BwiSearch />
    </button>
  )
}
